import ApplicationAdapter from 'garaje/adapters/application';
import config from 'garaje/config/environment';

export default class BadgeLogAdapter extends ApplicationAdapter {
  host = config.badgeLogApiHost;
  namespace = 'a/badge-log/v1';
}
